import React from 'react'
import { useTranslation } from 'react-i18next'

import DropdownMenu from 'components/DropdownMenu/DropdownMenu'
import { useAssetManager } from 'components/AssetManager'
import { ExitIcon, IconRename, TripleDotsIcon, PhotoIcon, EditMembers } from 'svg'

import './Dropdown.scss'

const Dropdown = ({
    organization,
    onLeaveFromOrganization,
    setIsEditableName,
    onUpdateOrganization,
    currentUserId,
    onOpenModalManageTeam,
}) => {
    const { t } = useTranslation()
    const { chooseAsset } = useAssetManager()

    const isOwner = organization.ownerId === currentUserId

    const actionMenuItems = [
        isOwner && (
            <p
                className="organization-panel__dropdown-menu-item"
                onClick={() =>
                    chooseAsset(organization.logoURL, value => onUpdateOrganization(organization, { logoURL: value }))
                }
            >
                <span className="organization-panel__dropdown-menu-icon">
                    <PhotoIcon />
                </span>
                {t('Change logo')}
            </p>
        ),
        isOwner && (
            <p className="organization-panel__dropdown-menu-item" onClick={() => setIsEditableName(true)}>
                <span className="organization-panel__dropdown-menu-icon">
                    <IconRename />
                </span>
                {t('Rename')}
            </p>
        ),
        isOwner && (
            <p className="organization-panel__dropdown-menu-item" onClick={evt => onOpenModalManageTeam(evt)}>
                <span className="organization-panel__dropdown-menu-icon">
                    <EditMembers />
                </span>
                {t('Manage team')}
            </p>
        ),
        !isOwner && (
            <p
                className="organization-panel__dropdown-menu-item"
                onClick={evt => onLeaveFromOrganization(organization.id, evt)}
            >
                <span className="organization-panel__dropdown-menu-icon">
                    <ExitIcon />
                </span>
                {t('Leave')}
            </p>
        ),
    ]

    return (
        <DropdownMenu
            className="organization-panel__dropdown-menu"
            actionHtml={<TripleDotsIcon />}
            items={actionMenuItems}
        />
    )
}

export default Dropdown
